module.exports = __webpack_public_path__ + "img/image1.45599c4b.png";